import { type IVector2, type IVector3 } from '@seddi/math-v2';
import WaGarmentsGeometry from '@seddi/wa-garments-geometry';

interface PointQueryRes {
  coordinates: IVector3;
  triangle: number;
}

export class TriMeshGrid2 {
  grid?: WaGarmentsGeometry.TriMeshGrid2F;

  // Wasm memory array life-cycle.
  private indices?: WaGarmentsGeometry.StdVectorU;
  private vertices?: WaGarmentsGeometry.StdVectorPoint2F;

  init(indices: Uint32Array, vertices: Float32Array, cellSize: number) {
    const nIndices = indices.length;
    this.indices = new WaGarmentsGeometry.StdVectorU();
    this.indices.resize(nIndices);
    const indicesData = this.indices.data();
    indicesData.set(indices);

    const nVertices = vertices.length / 2;
    this.vertices = new WaGarmentsGeometry.StdVectorPoint2F();
    this.vertices.resize(nVertices);
    const verticesData = this.vertices.data();
    verticesData.set(vertices);

    this.grid = new WaGarmentsGeometry.TriMeshGrid2F(this.indices, this.vertices, cellSize);
    // this.grid.bbox({ min: [0, 0], max: [0.5, 1] });
    this.grid.build();
  }

  dispose() {
    this.grid = undefined;
    this.indices = undefined;
    this.vertices = undefined;
  }

  query(point: IVector2): PointQueryRes {
    const res = this.grid!.query([point.x, point.y]);
    return {
      coordinates: {
        x: res.coordinates[0],
        y: res.coordinates[1],
        z: res.coordinates[2],
      },
      triangle: res.triangle,
    };
  }
}
